import { UPDATE_FILTER } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case UPDATE_FILTER.LOAD:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_FILTER.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case UPDATE_FILTER.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
